import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider, createBrowserRouter, createRoutesFromElements, Route } from 'react-router-dom';
import App from './App';
import LandingPage from './pages/LandingPage';
import ChatPage from './pages/ChatPage';
import DashboardPage from './pages/DashboardPage';
import AdminPage from './pages/AdminPage';
import ProfilePage from './pages/ProfilePage';
import ReflectionsPromptPage from './pages/ReflectionsPromptPage';
import WelcomeBackPage from './pages/WelcomeBackPage';
import './index.css';

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<App />}>
      <Route index element={<LandingPage />} />
      <Route path="chat" element={<ChatPage />} />
      <Route path="dashboard" element={<DashboardPage />} />
      <Route path="reflections" element={<ReflectionsPromptPage />} />
      <Route path="welcome-back" element={<WelcomeBackPage />} />
      <Route path="admin" element={<AdminPage />} />
      <Route path="profile" element={<ProfilePage />} />
    </Route>
  ),
  {
    future: {
      v7_relativeSplatPath: true
    }
  }
);

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find root element');

const root = createRoot(rootElement);
root.render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
);